module.exports = __webpack_public_path__ + "static/media/iconfont.e42ee0aa.eot";